const { getConfiguration, verifyExtend } = await import(window.extendAssetURLs.extendUtils);
const { initCartOffer } = await import(window.extendAssetURLs.extendCart);

//window.addEventListener('load', () => {
    try {
        const storeId = 'd1bde0f7-3340-43b9-940a-6f7b38687679';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
//});